import { FC } from 'react';
import './index.css';

const Dots: FC = () => <div className="dots" />;

export default Dots;
